import React from "react";

export default function ShareIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Group_21753"
      data-name="Group 21753"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <path
        id="Path_16067"
        data-name="Path 16067"
        d="M0,0H32V32H0Z"
        fill="none"
      />
      <path
        id="Path_16068"
        data-name="Path 16068"
        d="M16.827,22.031l-5.6-3.053a5.333,5.333,0,1,1,0-7.287l5.6-3.053a5.333,5.333,0,1,1,1.279,2.34l-5.6,3.053a5.344,5.344,0,0,1,0,2.605l5.6,3.053a5.333,5.333,0,1,1-1.279,2.34ZM7.333,18a2.667,2.667,0,1,0-2.667-2.667A2.667,2.667,0,0,0,7.333,18ZM22,10a2.667,2.667,0,1,0-2.667-2.667A2.667,2.667,0,0,0,22,10Zm0,16a2.667,2.667,0,1,0-2.667-2.667A2.667,2.667,0,0,0,22,26Z"
        transform="translate(0.667 0.666)"
        fill="#fff"
      />
    </svg>
  );
}
